import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface ElectricalProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Electrical: React.FC<ElectricalProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [electrical, set_electrical] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Major Systems Rough-ins']?.['Electrical'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Major Systems Rough-ins': { ...b.values?.['Major Systems Rough-ins'], 'Electrical': v } } })
    );
    const label = 'Electrical (except fixtures)';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(electrical)}
                />
            ) : (
                <MoneyBox
                    id={'electrical'}
                    allowNegative={false}
                    value={electrical}
                    onChange={(value) => set_electrical(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
